import src from "IMAGE";
export default { src, width: 147, height: 190, blurWidth: 0, blurHeight: 0};
